import { createFeatureSelector } from '@ngrx/store';

import { AppState } from '@app/sharedModule/models/app-state.model';
import * as fromPreview from '../reducers';

export const previewSelector = createFeatureSelector<AppState, fromPreview.PreviewState>(fromPreview.featureKey);
